import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { moderateScale, scale, verticalScale } from 'react-native-size-matters';
import { View, StyleSheet, Image, Dimensions, Platform } from 'react-native';
import FastImage from 'react-native-fast-image'
import { defaultScale } from '../../utils/scaling'

import Theme from '../../theme';
const width = Dimensions.get('window').width;
const height = Dimensions.get("window").height;
const isWeb = Platform.OS === 'web';
const isLargeScreen = height > 850 && Platform.OS !== 'web';
class MealImage extends PureComponent {
    
    state = {
        imageWidth: defaultScale(120),
        imageHeight: defaultScale(80),
    }

    render() {
        const { mealImagUrl, t, mealImageBorderRadius = 0 } = this.props;
        const { size, imageWidth, imageHeight } = this.state;
        let avatarElement = (
            <View style={{
                width: imageWidth,
                height: imageHeight,
                backgroundColor: Theme.CHARCOAL,
                borderRadius: mealImageBorderRadius
            }} />
        );

        if (mealImagUrl) {
            avatarElement = (
                <Image
                    resizeMode={"cover"}
                    style={{
                        width: imageWidth,
                        height: imageHeight,
                        margin: 2.5,
                        borderRadius: 3
                    }}
                    source={{ uri: mealImagUrl }}
                />
            );
        }

        return avatarElement;
    }
}

MealImage.propTypes = {
};

export default MealImage;
